import { useState } from 'react'
import { toast } from 'react-toastify'

import {
  useGetCampaignLeads,
  useSyncCampaignLeads,
  useGetCampaignSequence,
} from '../sequences_api'
import { LeadsEmptyState } from './LeadsEmptyState'
import { LeadsTable } from './LeadsTable'

interface LeadsTabProps {
  campaignId: number
}

export function LeadsTab({ campaignId }: LeadsTabProps) {
  const [page, setPage] = useState(1)

  // Get sequence to access bison_campaign_id
  const { data: sequence, isLoading: isLoadingSequence } =
    useGetCampaignSequence(campaignId)

  const bisonCampaignId = sequence?.bison_campaign_id

  const {
    data: leadsData,
    isLoading: isLoadingLeads,
    isFetching,
  } = useGetCampaignLeads(bisonCampaignId || 0, page)
  const syncMutation = useSyncCampaignLeads(bisonCampaignId || 0)

  const handleSync = async () => {
    try {
      const result = await syncMutation.mutateAsync()
      toast.success(result.message || 'Leads synced successfully')
      // Reset to first page after sync
      setPage(1)
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.detail || 'Failed to sync leads'
      toast.error(errorMessage)
    }
  }

  if (isLoadingSequence || (isLoadingLeads && !leadsData)) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500">Loading...</div>
      </div>
    )
  }

  if (!bisonCampaignId) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500">No EmailBison campaign found</div>
      </div>
    )
  }

  if (leadsData && leadsData.count === 0) {
    return (
      <LeadsEmptyState onSync={handleSync} isSyncing={syncMutation.isPending} />
    )
  }

  return (
    <LeadsTable
      data={leadsData}
      page={page}
      setPage={setPage}
      onSync={handleSync}
      isSyncing={syncMutation.isPending}
      isLoading={isFetching}
    />
  )
}
